import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "overlay", "amount", "form", "userName", "summerPromotion"]

  open(event) {
    event.preventDefault()
    const { url, userName, currentAmount } = event.currentTarget.dataset

    this.userNameTarget.textContent = userName
    this.amountTarget.value = currentAmount || ""
    this.formTarget.action = url
    if (this.hasSummerPromotionTarget) {
      this.summerPromotionTarget.checked = false
    }

    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"

    // Focus the input after the modal is visible
    requestAnimationFrame(() => this.amountTarget.focus())
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  closeOnOverlay(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
